import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { ApiClientService, Otkupne_cijene } from '../../../services/api-client.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-otkupne-cijene',
  templateUrl: './otkupne-cijene.component.html',
  styleUrls: ['./otkupne-cijene.component.scss']
})
export class OtkupneCijeneComponent implements OnInit {
  constructor(
    private apiClient: ApiClientService, 
    private cdRef: ChangeDetectorRef, 
    private userService: UserService
  ) {
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  startDate: Date = new Date(new Date().toDateString());
  endDate: Date = new Date(new Date(new Date().toDateString()).setHours(23, 59, 59, 999));
  gridData: any[] = [];
  loading: boolean = false;
  loadPanelPosition = { of: '#otkupneCijeneGrid' };
  createOtkupneCijenePopupVisible: boolean = false;
  isUserModerator: boolean = false;

  @ViewChild('otkupneCijeneGrid', { static: false }) otkupneCijeneGrid: DxDataGridComponent;

  ngOnInit() {
    this.isUserModerator = this.userService.isUserAgroModerator();
    console.log('User is moderator:', this.isUserModerator);
  }

  onStartDateChange(event: any) {
    this.startDate = event;
  }

  onEndDateChange(event: any) {
    this.endDate = event;
  }

  isFormValid(): boolean {
    return !!this.startDate && !!this.endDate;
  }

  toLocalAsUTC(date: Date): Date {
    const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return newDate;
  }

  async loadData() {
    if (!this.isFormValid()) {
      return;
    }

    this.loading = true;
    
    try {
      const result = await this.apiClient.otkupneCijeneAll(this.toLocalAsUTC(this.startDate), this.toLocalAsUTC(this.endDate));
      this.gridData = result;

    } catch (error) {
      console.error('Error loading otkupne cijene data:', error);
    } finally {
      this.loading = false;
    }
  }

  showCreateOtkupneCijene() {
    this.createOtkupneCijenePopupVisible = true;
  }

  async onOtkupneCijeneCreated(e: Otkupne_cijene) {
    await this.loadData();
  }

  async onDeleteClick(e: any) {
    this.loading = true;
    const otkupneCijene = e.row.data;

    try {
      await this.apiClient.otkupneCijeneDELETE(otkupneCijene.id);

      const index = this.gridData.findIndex(item => item.id === otkupneCijene.id);
      if (index > -1) {
        this.gridData.splice(index, 1);
        this.gridData = [...this.gridData]; // Trigger change detection
      }

      this.loading = false;
      this.cdRef.detectChanges();
    } catch (error) {
      this.loading = false;
      console.error('Error deleting otkupne cijene:', error);
    }
  }
}